import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, ThunderboltOutlined, SafetyCertificateOutlined, GlobalOutlined } from '@ant-design/icons';
import { agentAPI } from '../services/api';

const { Title, Text } = Typography;

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await agentAPI.login(values.email, values.password);
      localStorage.setItem('agent_token', res.data.token);
      localStorage.setItem('agent_info', JSON.stringify(res.data.agent));
      message.success('欢迎回来，' + (res.data.agent?.agent_name || '代理商'));
      navigate('/dashboard');
    } catch (err) {
      message.error(err.response?.data?.message || '登录失败，请检查账号密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* 背景装饰 */}
      <div style={{ position: 'absolute', top: -100, right: -100, width: 400, height: 400, borderRadius: '50%', background: 'rgba(102,126,234,0.15)', filter: 'blur(80px)' }} />
      <div style={{ position: 'absolute', bottom: -80, left: -80, width: 350, height: 350, borderRadius: '50%', background: 'rgba(118,75,162,0.12)', filter: 'blur(80px)' }} />

      {/* 左侧品牌区 */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center',
        alignItems: 'center', padding: 48, color: '#fff', position: 'relative', zIndex: 1,
      }}>
        <div style={{
          width: 120, height: 120, borderRadius: 30,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 32, boxShadow: '0 20px 60px rgba(102,126,234,0.4)',
          overflow: 'hidden',
        }}>
          <img src="/logo.png" alt="灵狐算力" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <Title level={1} style={{ color: '#fff', marginBottom: 8, fontSize: 42, fontWeight: 800 }}>灵狐算力</Title>
        <Title level={3} style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 400, marginTop: 0, marginBottom: 16 }}>
          企业管理控制台
        </Title>
        <Text style={{ color: 'rgba(255,255,255,0.55)', fontSize: 15 }}>
          数据驱动的AI模型服务运营平台
        </Text>
        <div style={{ marginTop: 48, display: 'flex', gap: 32 }}>
          {[
            { icon: <GlobalOutlined />, label: '多模型聚合' },
            { icon: <SafetyCertificateOutlined />, label: '安全可靠' },
            { icon: <ThunderboltOutlined />, label: '实时统计' },
          ].map((item, i) => (
            <div key={i} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 24, marginBottom: 8, color: 'rgba(255,255,255,0.7)' }}>{item.icon}</div>
              <Text style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>{item.label}</Text>
            </div>
          ))}
        </div>
      </div>

      {/* 右侧登录表单 */}
      <div style={{
        width: 500, display: 'flex', justifyContent: 'center', alignItems: 'center',
        background: 'rgba(255,255,255,0.98)', backdropFilter: 'blur(20px)',
        borderRadius: 0, boxShadow: '-20px 0 60px rgba(0,0,0,0.3)',
        position: 'relative', zIndex: 1,
      }}>
        <Card bordered={false} style={{ width: 400, boxShadow: 'none', background: 'transparent' }}>
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <Title level={3} style={{ marginBottom: 8, fontWeight: 700 }}>管理员登录</Title>
            <Text type="secondary">请输入您的企业管理账号密码</Text>
          </div>
          <Form onFinish={onFinish} size="large" autoComplete="off">
            <Form.Item name="email" rules={[
              { required: true, message: '请输入邮箱地址' },
              { type: 'email', message: '请输入有效的邮箱地址' },
            ]}>
              <Input
                prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
                placeholder="邮箱地址"
                style={{ borderRadius: 10, height: 48 }}
              />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
              <Input.Password
                prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
                placeholder="密码"
                style={{ borderRadius: 10, height: 48 }}
              />
            </Form.Item>
            <Form.Item style={{ marginTop: 32 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                style={{
                  height: 48, borderRadius: 10, fontSize: 16, fontWeight: 600,
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  border: 'none',
                }}
              >
                登录控制台
              </Button>
            </Form.Item>
          </Form>
          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <Text type="secondary" style={{ fontSize: 13 }}>
              如需开通企业平台账号，请联系平台管理员
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
}
